// Utilities
import createServiceAsyncThunk from "../../../utils/reduxUtils/createServiceAsyncThunk";
import createGenericSlice from "../../../utils/reduxUtils/createEntitySlice";

// Service
import { dailyReportService } from "../../../Api/Services/DailyReportService"; // Importing the daily report service to interact with the API

// Constants
import { ERROR_MESSAGES } from "../../../constants/error";
import { ACTION_NAMES, SLICE_NAMES } from "../../../constants/action";

// Types
import { IBaseResponse } from "../../../Types/UserProfileDetails";

/**
 * Async thunk to handle uppload daily report.
 * Dispatches an API call to the daily report service.
 */
export const uploadDailyReportAsyncThunk = createServiceAsyncThunk<
  IBaseResponse, // Response Type
  FormData // Payload Type
>(
  ACTION_NAMES.UPLOAD_DAILY_REPORT,
  (dailyReportData): any =>
    dailyReportService.uploadDailyReport(dailyReportData),
  ERROR_MESSAGES.UPLOAD_DAILY_REPORT_FAILURE
);

/**
 * Slice to manage the state for upload daily report.
 * Includes actions to clear errors and handle async states.
 */
export const uploadDailyReportSlice = createGenericSlice<
  IBaseResponse,
  FormData
>(
  SLICE_NAMES.UPLOAD_DAILY_REPORT, // Slice Name
  uploadDailyReportAsyncThunk // Async Thunk
);

// Export actions for dispatching in components
export const {
  clearError: clearUploadDailyReportError,
  clearSuccessMessage: clearUploadDailyReportSuccessMessage,
} = uploadDailyReportSlice.actions;

// Export the reducer to be used in the Redux store
export default uploadDailyReportSlice.reducer;
